"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dialog = void 0;
const react_1 = __importStar(require("react"));
const react_intl_1 = require("react-intl");
const lodash_1 = require("lodash");
const uuid_1 = require("uuid");
const Button_1 = __importDefault(require("@material-ui/core/Button"));
const ButtonGroup_1 = __importDefault(require("@material-ui/core/ButtonGroup"));
const CircularProgress_1 = __importDefault(require("@material-ui/core/CircularProgress"));
const Dialog_1 = __importDefault(require("@material-ui/core/Dialog"));
const DialogActions_1 = __importDefault(require("@material-ui/core/DialogActions"));
const DialogContent_1 = __importDefault(require("@material-ui/core/DialogContent"));
const DialogTitle_1 = __importDefault(require("@material-ui/core/DialogTitle"));
const Typography_1 = __importDefault(require("@material-ui/core/Typography"));
const draggable_paper_1 = require("../draggable-paper/draggable-paper");
const event_callback_hook_1 = require("../../utils/event-callback-hook");
const dialog_context_1 = require("./dialog-context");
const dialog_styles_1 = require("./dialog-styles");
exports.Dialog = (0, react_1.forwardRef)(function Dialog({ title, children, onConfirm = lodash_1.stubTrue, onCancel = lodash_1.noop, onShow = lodash_1.noop, onShown = lodash_1.noop, showConfirm = true, confirmLabel, showClose = true, closeLabel, actions, loading = false, disableBackdrop = false, confirmOnEnter = false, maxWidth = 'lg', fullWidth = false, }, ref) {
    const handleId = (0, react_1.useRef)(`dialog-${(0, uuid_1.v4)()}`);
    const classes = (0, dialog_styles_1.useStyles)();
    const [opened, setOpened] = (0, react_1.useState)(false);
    const open = (0, event_callback_hook_1.useEventCallback)(() => {
        onShow();
        requestAnimationFrame(() => {
            onShown();
        });
        setOpened(true);
    });
    const close = (0, event_callback_hook_1.useEventCallback)(() => setOpened(false));
    const handleConfirm = (0, event_callback_hook_1.useEventCallback)(async () => {
        let result = onConfirm();
        if (result instanceof Promise) {
            result = await result;
        }
        if (result !== false) {
            close();
        }
    });
    const handleCancel = (0, event_callback_hook_1.useEventCallback)(() => {
        onCancel();
        close();
    });
    (0, react_1.useImperativeHandle)(ref, () => ({
        open,
        close,
    }), [close, open]);
    const handleDialogClick = (0, event_callback_hook_1.useEventCallback)((event) => event.stopPropagation());
    const handleKeyDown = (0, event_callback_hook_1.useEventCallback)((event) => {
        if (!confirmOnEnter ||
            loading ||
            event.defaultPrevented ||
            event.key !== 'Enter') {
            return;
        }
        if (event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) {
            return;
        }
        const target = event.target;
        const tagName = target === null || target === void 0 ? void 0 : target.tagName.toLowerCase();
        if (tagName === 'button' ||
            tagName === 'textarea' ||
            (target === null || target === void 0 ? void 0 : target.isContentEditable) ||
            (target === null || target === void 0 ? void 0 : target.getAttribute('aria-expanded')) === 'true') {
            return;
        }
        event.preventDefault();
        handleConfirm();
    });
    return (react_1.default.createElement(dialog_context_1.DialogContext.Provider, { value: { handleId: handleId.current } },
        react_1.default.createElement(Dialog_1.default, { onClick: handleDialogClick, onKeyDown: handleKeyDown, open: opened, onClose: handleCancel, PaperComponent: draggable_paper_1.DragablePaper, maxWidth: maxWidth, fullWidth: fullWidth, disableBackdropClick: disableBackdrop, "data-cy": "EAS__DIALOG" },
            react_1.default.createElement(DialogTitle_1.default, { id: handleId.current, disableTypography: true, classes: { root: classes.title } },
                react_1.default.createElement(Typography_1.default, { className: classes.titleHeader, variant: "h6" }, title)),
            react_1.default.createElement(DialogContent_1.default, { dividers: true }, opened && children()),
            (showConfirm || actions || showClose) && (react_1.default.createElement(DialogActions_1.default, { classes: { root: classes.actions } },
                react_1.default.createElement(ButtonGroup_1.default, { size: "small", variant: "outlined" },
                    showConfirm && (react_1.default.createElement(Button_1.default, { type: "submit", onClick: handleConfirm, variant: "outlined", color: "primary", disabled: loading, startIcon: loading && react_1.default.createElement(CircularProgress_1.default, { size: "20px", color: "inherit" }) },
                        react_1.default.createElement(Typography_1.default, { classes: { root: classes.buttonLabel } }, confirmLabel !== null && confirmLabel !== void 0 ? confirmLabel : (react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS_DIALOG_BTN_CONFIRM", defaultMessage: "Potvrdit" }))))),
                    typeof actions === 'function' ? actions(loading) : actions,
                    showClose && (react_1.default.createElement(Button_1.default, { variant: "outlined", onClick: handleCancel, disabled: loading },
                        react_1.default.createElement(Typography_1.default, { classes: { root: classes.buttonLabel } }, closeLabel !== null && closeLabel !== void 0 ? closeLabel : (react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS_DIALOG_BTN_CANCEL", defaultMessage: "Zru\u0161it" })))))))))));
});
//# sourceMappingURL=dialog.js.map